import React, { useState, useEffect } from "react";
import { TraderUnitService } from "../../../services";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";

const UnitDashboard = ({ children }) => {
  const [selectedTraderUnit, setSelectedTraderUnit] = useState(null);
  const { unitId } = useParams();
  useEffect(() => {
    const bootstrapAsync = async () => {
      const traderUnit = await TraderUnitService.getTraderUnitById(unitId);
      setSelectedTraderUnit({
        id: traderUnit?.data?.id,
        name: traderUnit?.data?.unitName,
      });
    };
    bootstrapAsync();
  }, []);

  return (
    <React.Fragment>
      <section className="edit-form-table mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-2">
              <aside>
                <ul className="list-unstyled ps-0 sidemenu">
                  <li className="mb-1">
                    <button
                      className="btn btn-toggle btn-toggle-nw align-items-center  collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#home-collapse"
                      aria-expanded="false"
                    >
                      Home{" "}
                      {selectedTraderUnit &&
                        "(" + selectedTraderUnit?.name + ")"}
                    </button>
                    <div className="collapse show submenu" id="home-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EDIT_TRADER_UNIT.replace(
                              ":unitId",
                              selectedTraderUnit?.id
                            )}
                            className="link-dark"
                          >
                            Unit Information
                          </Link>
                        </li>

                        <li>
                          <Link
                            to={routes.TRADER_UNIT_SHOPFRONT.replace(
                              ":unitId",
                              selectedTraderUnit?.id
                            )}
                            className="link-dark "
                          >
                            Menus/Products
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={routes.TRADER_UNIT_DOCUMENT.replace(
                              ":unitId",
                              selectedTraderUnit?.id
                            )}
                            className="link-dark "
                          >
                            Documents
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  {/* <li className="mb-1">
                    <button
                      className="btn btn-toggle btn-toggle-nw align-items-center  collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#dashboard-collapse"
                      aria-expanded="false"
                    >
                      ShopFront
                    </button>
                    <div className="collapse submenu" id="dashboard-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EVENT_CREATE_APPLICATION.replace(
                              ":param",
                              "C"
                            )}
                            className="link-dark "
                          >
                            Documents
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="mb-1">
                    <button
                      className="btn btn-toggle btn-toggle-nw align-items-center "
                      data-bs-toggle="collapse"
                      data-bs-target="#orders-collapse"
                      aria-expanded="true"
                    >
                      Menus
                    </button>
                    <div className="collapse submenu" id="orders-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EVENT_CREATE_APPLICATION.replace(
                              ":param",
                              "R"
                            )}
                            className="link-dark "
                          >
                            Applications
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li className="mb-1">
                    <button
                      className="btn btn-toggle-nw align-items-center "
                      data-bs-toggle="collapse"
                      data-bs-target="#tickets-collapse"
                      aria-expanded="true"
                    >
                      Ticketing
                    </button>
                    <div className="collapse submenu" id="tickets-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EVENT_CREATE_TICKET}
                            className="link-dark "
                          >
                            Create
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={routes.EVENT_TICKETS}
                            className="link-dark "
                          >
                            Insights
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li> */}
                </ul>
              </aside>
            </div>
            <div className="col-md-10">{children}</div>
          </div>

          <div></div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(UnitDashboard);
